import { render, staticRenderFns } from "./RegionImage.vue?vue&type=template&id=ca674158&scoped=true&"
import script from "./RegionImage.vue?vue&type=script&lang=js&"
export * from "./RegionImage.vue?vue&type=script&lang=js&"
import style0 from "./RegionImage.vue?vue&type=style&index=0&id=ca674158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca674158",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca674158')) {
      api.createRecord('ca674158', component.options)
    } else {
      api.reload('ca674158', component.options)
    }
    module.hot.accept("./RegionImage.vue?vue&type=template&id=ca674158&scoped=true&", function () {
      api.rerender('ca674158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/engineers/regionConfig/RegionImage.vue"
export default component.exports